import { useSelector } from 'react-redux';
import { useActivePlan } from '@/services/hooks/useActivePlan';
import { getGeneralInfo } from '@/store/account/actions';
import { getPrebuildModulesStore } from '@/store/prebuildModules/actions';
import { ProductType } from '@dev/ee-api/ee-api-models';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';

interface LimitsProps {
    isSaveUpgradeable: boolean;
    isSavedDisabled: boolean;
    isSaveLocked: boolean;
    savedLimit: number;
    savedCount: number;
    savedRemaining: number;
}

export const useSavedLimits = (): LimitsProps => {
    const { ActivePlanDetails } = useActivePlan();
    const { IsPro: isPro, IsLegacy, ProductType: productType } = useSelector(getGeneralInfo);
    const { list: savedPrebuildModulesList } = useSelector(getPrebuildModulesStore);
    const { isStandardPlan } = useCurrentPlanStatus();

    const savedLimit = ActivePlanDetails?.Limits?.EditorPreBuildLimit ?? 0;
    const savedCount = savedPrebuildModulesList?.length ?? 0;
    const savedRemaining = savedLimit - savedCount;
    const isCreatorProduct = productType === ProductType.CreatorSuite;
    const isSaveUpgradeable = isCreatorProduct ? !isStandardPlan : !isPro;

    return {
        isSavedDisabled: IsLegacy,
        isSaveLocked: savedLimit === 0,
        isSaveUpgradeable,
        savedLimit,
        savedCount,
        savedRemaining
    };
};
